class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    // Use composedPath when available to correctly detect clicks coming from
    // shadow DOM, virtual keyboards, or other composed contexts.
    const path = event.composedPath ? event.composedPath() : event.path || [];

    const clickedInside = path.some((el) => el === this || el === this.detailsContainer || (el && el.nodeType === 1 && this.contains(el)));
    const clickedOverlay = path.some((el) => el && el.classList && el.classList.contains && el.classList.contains('modal-overlay'));

    // If the click originated inside a predictive-search/results area, ignore it.
    const clickedPredictive = path.some(
      (el) => el && el.classList && el.classList.contains && (
        el.classList.contains('predictive-search') ||
        el.classList.contains('predictive-search--header') ||
        el.classList.contains('predictive-search--search-template') ||
        el.classList.contains('predictive-search__results')
      )
    );

    // Lightweight debug to help during repro (no-op on production if console filtered)
    try {
      console.debug('DetailsModal: onBodyClick', { clickedInside, clickedOverlay, clickedPredictive, pathLength: path.length });
    } catch (e) {}

    // If overlay was clicked, close as expected
    if (clickedOverlay) {
      this.close(false);
      return;
    }

    // Ignore clicks that are inside the modal or originated from predictive results
    if (clickedInside || clickedPredictive) return;

    // Ignore synthetic clicks that often come from virtual keyboards or IME interactions
    // (these frequently have detail === 0 and coordinates 0,0). If it's a user click, close.
    try {
      if (event && event.detail === 0 && event.clientX === 0 && event.clientY === 0) return;
    } catch (e) {}

    this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
